var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"4","height":"6","viewBox":"0 0 4 6","fill":"#C1C7CC","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M3.587 3.297l-2.58 2.58a.42.42 0 11-.594-.594L2.696 3 .413.717a.42.42 0 01.594-.594l2.58 2.58a.419.419 0 010 .594z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }